export const formatSingleDigit = (number:any) => {
    const result = number.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
    return result
}